import React, { Suspense } from 'react';
import { Grid, Icon, Divider, Tab, Tabs, Typography, Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useStyles } from './style';
import { Loader } from '../../elements';
import { LoaderSize } from '../../constants/constants';

const InjectorsTable = React.lazy(() => import('../../components/InjectorsTable/component'));
const DevicesFirmware = React.lazy(() => import('../../components/DevicesFirmware/component'));
const ReadingDevicesTable = React.lazy(() => import('../../components/ReadingDevicesTable'));
const ReaderActionsTable = React.lazy(() => import('../../components/ReaderActionsTable/component'));

const DevicesPage: React.FC<any> = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { option } = useParams<{ option: string }>();

  const tabValues: { [key: string]: string } = {
    injectors: 'injectors',
    firmware: 'firmware',
    readers: 'readers',
    'reader-actions': 'reader-actions'
  };

  const getTabIndex = (): string => {
    const index = tabValues[option as string];
    return index ? index : tabValues.injectors;
  };

  const [tab, setTab] = React.useState(getTabIndex());

  React.useEffect(() => {
    const tabIndex = getTabIndex();
    setTab(tabIndex);
  }, [option]);

  const handleTabChange = (_event: React.ChangeEvent<any>, newValue: string) => {
    setTab(newValue);
    navigate(`/devices/${newValue}`);
  };

  return (
    <Container maxWidth="lg">
      <Grid container item xs={12}>
        <Grid container>
          <Grid item>
            <Icon fontSize="large" color="primary">
              {'admin_panel_settings'}
            </Icon>
          </Grid>
          <Grid item>
            <Typography component="h2" variant="h6" color="primary">
              {t('f-devices')}
            </Typography>
          </Grid>
        </Grid>

        {/* todo: Fix scroll of tabs on small screens */}
        <Grid container className={classes.mt1} direction="column">
          <Tabs value={tab} onChange={handleTabChange} scrollButtons="auto">
            <Tab label={t('f-devices-injectors-title')} value={'injectors'} />
            <Tab label={t('f-devices-firmware-title')} value={'firmware'} />
            <Tab disabled label={t('f-devices-readers-title')} value={'readers'} />
            <Tab label={t('f-devices-readers-actions-title')} value={'reader-actions'} />
          </Tabs>
          <Divider />
        </Grid>

        <Grid container className={classes.mt4}>
          <Grid item xs={12} md={12}>
            {(() => {
              switch (tab) {
                case tabValues['injectors']:
                  return (
                    <Suspense fallback={<Loader isLoading={true} size={LoaderSize.DEFAULT_SIZE} />}>
                      <InjectorsTable />
                    </Suspense>
                  );
                case tabValues['firmware']:
                  return (
                    <Suspense fallback={<Loader isLoading={true} size={LoaderSize.DEFAULT_SIZE} />}>
                      <DevicesFirmware />
                    </Suspense>
                  );
                case tabValues['readers']:
                  return (
                    <Suspense fallback={<Loader isLoading={true} size={LoaderSize.DEFAULT_SIZE} />}>
                      <ReadingDevicesTable />
                    </Suspense>
                  );
                case tabValues['reader-actions']:
                  return (
                    <Suspense fallback={<Loader isLoading={true} size={LoaderSize.DEFAULT_SIZE} />}>
                      <ReaderActionsTable />
                    </Suspense>
                  );
              }
            })()}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DevicesPage;
